import styled from '@emotion/styled'
import Grid from '@mui/material/Grid'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../components'
import MySVG from '../../../../components/Icons'

const Wrapper = styled(Grid)`
  ${p => p.theme.colors.white};
  height: 100vh;
  flex: 1;
  position: relative;
  background-color: ${p => p.theme.colors.darkGrey};
  padding: 52px 25px;
  color: #fff;
  @media (max-width: 599px) {
    padding: 52px 5px;
  }
`

const InnerWrapper = styled.div`
  max-width: 475px;
  text-align: center;
  margin: 90px 80px;

  @media (max-width: 699px) {
    margin: 90px 10px;
  }
`

const HeaderText = styled.h2`
  font-family: system-ui, -apple-system, sans-serif;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin-top: 30px;
  @media (max-width: 699px) {
    font-size: 26px;
  }
`
const SubheaderText = styled.h3`
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
`

export const CreateAccountSuccess = () => {
  const navigate = useNavigate()

  return (
    <Wrapper item xs={12} md={9} lg={10}>
      <InnerWrapper>
        <img src={MySVG.CheckmarkCircle} alt="checkmark circle" />
        <HeaderText>Check your email</HeaderText>
        <SubheaderText>
          We sent a verification link to your email address. Click the link to
          activate your account, then sign in.
        </SubheaderText>
        <Button mt="32px" type="button" onClick={() => navigate('/signin')}>
          Go to Sign In
        </Button>
      </InnerWrapper>
    </Wrapper>
  )
}
